module.exports = __webpack_public_path__ + "static/profile-round-small-35161802be34953a70068fc7102f7339.png";